// extracted by mini-css-extract-plugin
export default {"productGrid":"t0-z","centerLink":"u0-z","productSection":"v0-z","item":"w0-z","ctaButton":"x0-z"};